import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ExternalReviewLinks = () => {
  const reviewPlatforms = [
    {
      name: 'Google Reviews',
      icon: 'Star',
      rating: '4.6',
      reviewCount: '76',
      url: 'https://www.google.com/search?sca_esv=9c0efc319e90ebc6&sxsrf=AE3TifONL15NZkA8aPFxq5Yo2h51LUscQw:1753859863220&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E1iH_VT6gkRm4Q4aam_0CeEe2UKQXheHuWgnwiUuJD1xbIuDZSYq6BY5x8nUU0BUUvx3qiB7fZ2CQUEvmFfXkdP_6P2hbgmp7gI4eVYxKtvamkQ5XQ%3D%3D&q=Luxe+%26+Allure+Events+Limited+Reviews&sa=X&ved=2ahUKEwiZ-IeRheSOAxX8VaQEHYLCPNwQ0bkNegQIIhAE&biw=1920&bih=957&dpr=1#',
      color: 'text-blue-600'
    },
    {
      name: 'Facebook',
      icon: 'Facebook',
      rating: '4.8',
      reviewCount: '36',
      url: 'https://www.facebook.com/luxeallureevents/',
      color: 'text-blue-700'
    },
    {
      name: 'WeddingWire',
      icon: 'Heart',
      rating: '4.9',
      reviewCount: '15',
      
      color: 'text-pink-600'
    }
  ];

  return (
    <div className="bg-card elevation-card rounded-lg p-6 mb-8">
      <div className="text-center mb-6">
        <h3 className="font-heading text-xl font-bold text-foreground mb-2">
          See More Reviews
        </h3>
        <p className="font-body text-muted-foreground">
          Check out what our clients are saying on other platforms
        </p>
      </div>
      
      <div className="grid sm:grid-cols-3 gap-4">
        {reviewPlatforms.map((platform) => (
          <a
            key={platform.name}
            href={platform.url}
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            <div className="bg-muted rounded-lg p-4 hover-scale transition-smooth hover:bg-muted/80">
              <div className="text-center">
                <div className={`inline-flex items-center justify-center w-12 h-12 rounded-lg bg-background mb-3 ${platform.color}`}>
                  <Icon name={platform.icon} size={24} />
                </div>
                <h4 className="font-body font-semibold text-foreground mb-1">
                  {platform.name}
                </h4>
                <div className="flex items-center justify-center space-x-1 mb-1">
                  <Icon name="Star" size={14} className="text-accent fill-current" />
                  <span className="font-mono text-sm font-semibold text-foreground">
                    {platform.rating}
                  </span>
                </div>
                <p className="font-caption text-xs text-muted-foreground">
                  {platform.reviewCount} reviews
                </p>
              </div>
            </div>
          </a>
        ))}
      </div>
      
      <div className="text-center mt-6">
        <Button
          variant="outline"
          size="sm"
          iconName="ExternalLink"
          iconPosition="right"
          onClick={() => window.open('https://www.google.com/search?sca_esv=9c0efc319e90ebc6&sxsrf=AE3TifONL15NZkA8aPFxq5Yo2h51LUscQw:1753859863220&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E1iH_VT6gkRm4Q4aam_0CeEe2UKQXheHuWgnwiUuJD1xbIuDZSYq6BY5x8nUU0BUUvx3qiB7fZ2CQUEvmFfXkdP_6P2hbgmp7gI4eVYxKtvamkQ5XQ%3D%3D&q=Luxe+%26+Allure+Events+Limited+Reviews&sa=X&ved=2ahUKEwiZ-IeRheSOAxX8VaQEHYLCPNwQ0bkNegQIIhAE&biw=1920&bih=957&dpr=1#', '_blank')}
        >
          View All External Reviews
        </Button>
      </div>
    </div>
  );
};

export default ExternalReviewLinks;